module.exports = __webpack_public_path__ + "img/peoples.5268f502.svg";